// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__caH-e","vLegacy":"SelectSecondary_vLegacy__11Icy","error":"SelectSecondary_error__1QLlz","disabled":"SelectSecondary_disabled__3BNbu"};